"use strict";
import {http} from '../../../core';
import Config from "../../../app.config";
const RequestService = http.create();


export default {
    //服务台报表
    //重大事件统计
    greatEventList(params){
        return RequestService.get('event/event_big',params)
    },
    //事件是否及时关闭及满意度调查统计
    closeEventReview(params){
        return RequestService.get('event/event_close_review',params)
    },
    //事件生成类型统计
    eventTypeList(params){
        return RequestService.get('event/event_type',params)
    },
    //服务台受理与直接处理完成事件统计
    acceptCompleteList(params){
        return RequestService.get('event/event_reception_complete',params)
    },
    //事件完成统计
    eventCompleteList(params){
        return RequestService.get('event/event_complete_statistics',params)
    },
    //事件超时统计
    eventOutTime(params){
        return RequestService.get('event/event_out_time',params)
    },
    //未分配工单数（按天）
    undistributedWork(params){
        return RequestService.get('event/event_not_distribution',params)
    },
    //工作效率统计
    getWorkEfficiency(params){
        return RequestService.get('event/work_efficiency',params)
    }



}
